import { Link } from 'react-router-dom';
import Header from '../../home/components/Header';
import Footer from '../../home/components/Footer';

export default function DeliveryService() {
  const services = [
    {
      icon: 'ri-shopping-cart-line',
      title: 'Courses Personnelles',
      description: 'Vos courses alimentaires et produits du quotidien',
      price: '12€ + produits',
      features: [
        'Liste de courses personnalisée',
        'Sélection produits frais de qualité',
        'Respect de vos marques préférées',
        'Livraison sous 2-3h',
        'Rangement des courses inclus',
        'Ticket de caisse fourni'
      ]
    },
    {
      icon: 'ri-truck-line',
      title: 'Livraison Express',
      description: 'Service urgent pour particuliers et professionnels',
      price: 'À partir de 15€',
      features: [
        'Livraison sous 2h garantie',
        'Produits urgents et médicaments',
        'Documents importants',
        'Suivi temps réel par SMS',
        'Confirmation de réception',
        'Service 7j/7'
      ]
    },
    {
      icon: 'ri-building-2-line',
      title: 'Livraison Entreprise',
      description: 'Solutions logistiques pour professionnels',
      price: 'Sur contrat',
      features: [
        'Fournitures de bureau régulières',
        'Produits d\'entretien professionnel',
        'Livraisons programmées',
        'Facturation centralisée mensuelle',
        'Gestionnaire dédié',
        'Volumes préférentiels'
      ]
    }
  ];

  const deliveryZones = [
    {
      zone: 'Montréal Centre',
      areas: ['Ville-Marie', 'Plateau Mont-Royal', 'Rosemont', 'Villeray'],
      time: '1-2h',
      price: '8€'
    },
    {
      zone: 'Montréal Est/Ouest',
      areas: ['Anjou', 'Mercier', 'Saint-Léonard', 'Côte-des-Neiges'],
      time: '2-3h',
      price: '12€'
    },
    {
      zone: 'Banlieue Proche',
      areas: ['Laval', 'Longueuil', 'Brossard', 'Saint-Lambert'],
      time: '3-4h',
      price: '15€'
    },
    {
      zone: 'Rive-Sud/Nord',
      areas: ['Châteauguay', 'Saint-Jean', 'Terrebonne', 'Repentigny'],
      time: '4-5h',
      price: '20€'
    }
  ];

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-gray-50/30">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative py-24 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(249, 115, 22, 0.8), rgba(234, 88, 12, 0.8)), url('https://readdy.ai/api/search-image?query=Professional%20delivery%20and%20shopping%20service%20with%20grocery%20bags%2C%20delivery%20truck%2C%20orange%20and%20white%20color%20scheme%2C%20high%20quality%20photography%2C%20fresh%20groceries%2C%20professional%20delivery%20person%2C%20modern%20logistics%2C%20efficient%20service%2C%20customer%20satisfaction%2C%20shopping%20cart%20with%20products&width=1920&height=800&seq=delivery-hero&orientation=landscape')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <div className="mb-6">
            <Link to="/" className="inline-flex items-center text-orange-200 hover:text-white transition-colors cursor-pointer">
              <i className="ri-arrow-left-line mr-2"></i>
              Retour à l'accueil
            </Link>
          </div>
          
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            Courses & Livraison
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-4xl mx-auto">
            Services de courses personnelles et livraison pour particuliers et entreprises
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={scrollToContact}
              className="bg-white text-orange-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-shopping-cart-line mr-2"></i>
              Commander Service
            </button>
            <button
              onClick={() => window.location.href = 'tel:+14384081200'}
              className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-orange-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              438 408 1200
            </button>
          </div>
        </div>
      </section>

      {/* Services détaillés */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Nos Services de Livraison
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Solutions adaptées à tous vos besoins de courses et livraison
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-gray-50 rounded-xl overflow-hidden hover:shadow-lg transition-shadow">
                <div 
                  className="h-48 bg-cover bg-center relative"
                  style={{
                    backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20delivery%20service%20$%7Bservice.title.toLowerCase%28%29%7D%20with%20grocery%20bags%2C%20delivery%20equipment%2C%20orange%20and%20white%20color%20scheme%2C%20high%20quality%20photography%2C%20fresh%20products%2C%20professional%20delivery%2C%20modern%20logistics%2C%20customer%20service&width=600&height=400&seq=delivery-detail-${index}&orientation=landscape')`
                  }}
                >
                  <div className="absolute inset-0 bg-orange-600/20"></div>
                  <div className="absolute top-4 left-4 w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center">
                    <i className={`${service.icon} text-2xl text-white`}></i>
                  </div>
                </div>
                
                <div className="p-6">
                  <div className="flex justify-between items-start mb-4">
                    <h3 className="text-2xl font-bold text-gray-900">{service.title}</h3>
                    <span className="text-lg font-semibold text-orange-600">{service.price}</span>
                  </div>
                  
                  <p className="text-gray-600 mb-6">{service.description}</p>
                  
                  <ul className="space-y-3 mb-6">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start">
                        <i className="ri-check-line text-orange-500 mr-3 mt-1"></i>
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  
                  <button
                    onClick={scrollToContact}
                    className="w-full bg-orange-600 text-white py-3 rounded-lg font-semibold hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Commander maintenant
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Zones de livraison */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Zones de Livraison
            </h2>
            <p className="text-xl text-gray-600">
              Nous couvrons tout Montréal et la région métropolitaine
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {deliveryZones.map((zone, index) => (
              <div key={index} className="bg-white rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="text-center mb-4">
                  <div className="w-16 h-16 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-map-pin-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">{zone.zone}</h3>
                </div>
                
                <div className="space-y-3 mb-6">
                  {zone.areas.map((area, idx) => (
                    <div key={idx} className="flex items-center text-sm text-gray-600">
                      <i className="ri-checkbox-circle-line text-orange-500 mr-2"></i>
                      {area}
                    </div>
                  ))}
                </div>
                
                <div className="border-t pt-4">
                  <div className="flex justify-between items-center text-sm">
                    <span className="text-gray-600">Délai:</span>
                    <span className="font-semibold">{zone.time}</span>
                  </div>
                  <div className="flex justify-between items-center text-sm mt-2">
                    <span className="text-gray-600">Frais:</span>
                    <span className="font-semibold text-orange-600">{zone.price}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Comment ça marche */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Comment Ça Marche ?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              { step: '1', title: 'Commande', description: 'Appelez-nous ou utilisez notre formulaire en ligne', icon: 'ri-phone-line' },
              { step: '2', title: 'Liste', description: 'Transmettez votre liste ou vos besoins spécifiques', icon: 'ri-file-list-3-line' },
              { step: '3', title: 'Courses', description: 'Notre équipe effectue vos courses avec soin', icon: 'ri-shopping-cart-line' },
              { step: '4', title: 'Livraison', description: 'Réception à domicile selon vos préférences', icon: 'ri-home-line' }
            ].map((process, index) => (
              <div key={index} className="text-center">
                <div className="w-20 h-20 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${process.icon} text-2xl text-white`}></i>
                </div>
                <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-orange-600 font-bold">{process.step}</span>
                </div>
                <h3 className="text-xl font-semibold mb-3">{process.title}</h3>
                <p className="text-gray-600">{process.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}